import { useQuery } from '@apollo/client';

import {
  AvailabilityState,
  CatalogVariantFragmentFragment,
  WatchdogActiveQuery,
  WatchdogActiveQueryVariables,
} from '@notino/shared/definitions/types';

import { IVariant } from '@containers/ProductListing/model';
import { useUser } from '@queries/useUser';

import watchdogActiveQuery from './queries/watchdogActive.graphql';

type UseWatchdogActiveParams = {
  variant:
    | Pick<IVariant, 'id' | 'showWatchdog'>
    | Pick<CatalogVariantFragmentFragment, 'webId' | 'availability'>;
  cacheOnly?: boolean;
};

export const useWatchdogActive = ({
  variant,
  cacheOnly = true,
}: UseWatchdogActiveParams) => {
  const { isLoggedIn } = useUser();
  const showWatchdog =
    'webId' in variant
      ? variant.availability.state === AvailabilityState.ShowWatchdog
      : variant.showWatchdog;

  const canHaveActiveWatchdog = isLoggedIn && showWatchdog;
  const variantId = 'webId' in variant ? variant.webId : variant.id;

  const { data, updateQuery } = useQuery<
    WatchdogActiveQuery,
    WatchdogActiveQueryVariables
  >(watchdogActiveQuery, {
    variables: { productId: variantId },
    skip: !canHaveActiveWatchdog,
    ssr: false,
    fetchPolicy: cacheOnly ? 'cache-only' : 'cache-first',
  });

  const setWatchdogActiveCache = () => {
    updateQuery((prev) => ({
      ...prev,
      watchdogActive: { ...prev?.watchdogActive, watchdogActive: true },
    }));
  };

  return {
    watchdogActive: data?.watchdogActive?.watchdogActive,
    setWatchdogActiveCache,
  };
};
